import { createContext, useContext, useState } from "react";
const GlobalContext = createContext();
export const useGlobalContext = () => useContext(GlobalContext);

export const API_URL = process.env.REACT_APP_API_URL;
export const RUN_DINAR_URL = process.env.REACT_APP_RUN_DINAR_URL;
export const RUN_B2B_URL = process.env.REACT_APP_RUN_B2B_URL;

export const getHeaders = () => {
  const headerText = new Headers();

  const username = sessionStorage.getItem("authUsername");
  const password = sessionStorage.getItem("authPassword");

  headerText.append("Content-Type", "application/json;charset=UTF-8");
  headerText.append("Authorization", "Basic " + btoa(`${username}:${password}`));
  return headerText;
};

const AppContext = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [isRecuperar, setIsRecuperar] = useState(false);

  const [usuario, setUsuario] = useState();

  const headerText = getHeaders();

  const [baseUrl, setBaseUrl] = useState(API_URL);

  // backgroundColor: "#007ad9"
  const [styleProperties, setStyleProperties] = useState({
    logo: "assets/layout/images/logo_sack.png",
    title: "Planificador",
    backgroundColor: "lightblue",
    button: {
      backgroundColor: "#20ba84",
      foreColor: "#fff",
      border: "1px solid #007ad9",
    },
  });

  return (
    <GlobalContext.Provider
      value={{
        baseUrl,
        setBaseUrl,
        styleProperties,
        setStyleProperties,
        isLoggedIn,
        setIsLoggedIn,
        usuario,
        setUsuario,
        isRecuperar,
        setIsRecuperar,
        headerText,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default AppContext;
